app.service("HandleColourService", ['$rootScope', function ($rootScope) {

    const service = this;
    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const HandleColourModel = modelConstructor.extend(modelConstructor.RouteModel, {
        id: "handle_colour",
        navigation_pointer: "handle_colour_id",
        name: "Handle Colour",
        next_model_id: "assembly"
    });

    this.factory = new modelConstructor.RouteFactory({

        choices: {
            copper: new RouteChoice({
                name: "Copper",
                img_src: "/img/browse/option/handle-colour/handle-colour-lazio-copper.jpg"
            }),

            matt_black: new RouteChoice({
                name: "Matt Black",
                img_src: "/img/browse/option/handle-colour/handle-colour-lazio-black.jpg"
            }),

            matt_white: new RouteChoice({
                name: "Matt White",
                img_src: "/img/browse/option/handle-colour/handle-colour-lazio-white.jpg"
            }),

            satin_chrome: new RouteChoice({
                name: "Satin Chrome",
                img_src: "/img/browse/option/handle-colour/handle-colour-lazio-satin-chrome.jpg"
            }),
            brushed_steel: new RouteChoice({
                name: "Dark Brushed Steel",
                img_src: "/img/browse/option/handle-colour/handle-colour-segreto-steel.png"
            }),

            brushed_nickel: new RouteChoice({
                name: "Brushed Nickel",
                img_src: "/img/browse/option/handle-colour/handle-colour-segreto-nickel.png"
            }),

            black: new RouteChoice({
                name: "Black",
                img_src: "/img/browse/option/handle-colour/handle-colour-segreto-black.png"
            })
        },

        birth: function (values) {
            return new HandleColourModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const browseID = variationIDs.browse_id;
        const baseComponentID = variationIDs.base_component_id;
        const siteRangeID = variationIDs.site_range_id;
        const styleID = variationIDs.style_id;

        if (browseID !== "solution" && baseComponentID !== "solution") {
            return;
        }

        const choices = {};


        const cacheStyles = $rootScope.model.cache_local_server.style.site_range[siteRangeID];
        const cacheStyle = cacheStyles ? cacheStyles.choices[styleID] : null;
        if (!cacheStyle || !cacheStyle.available_handle_colours) {
            return null
        }

        const choiceOrder = ['satin_chrome', 'brushed_steel', 'brushed_nickel'];
        for (let i = 0; i < choiceOrder.length; i++) {
            if (!cacheStyle.available_handle_colours[choiceOrder[i]]) {
                choiceOrder.splice(i, 1);
                i--;
            }
        }

        model.choices = siteHelper.cloneChoices(
            service.factory.choices
            , choiceOrder);

        model.choices = choices;
        model.choice_order = choiceOrder;
    }

}]);